module.exports = __webpack_public_path__ + "img/pic-logo-jd.9fcd8927.png";